/*
 * @Author: your name
 * @Date: 2021-04-09 11:23:16
 * @LastEditTime: 2021-04-09 11:32:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\router\modules\moneyManagement.js
 */
export default [
    {
      path: '/moneyManagement',
      component: resolve => require(['../../views/moneyManagement/index.vue'], resolve),
      meta: {
        title: '资金管理'
      }
    },
    {
        path: '/theBalanceof',
        component: resolve => require(['../../views/moneyManagement/theBalanceof/theBalanceof.vue'], resolve),
        meta: {
          title: '余额统计'
        }
    },
    {
        path: '/moneyMonitor',
        component: resolve => require(['../../views/moneyManagement/moneyMonitor/moneyMonitor.vue'], resolve),
        meta: {
          title: '资金监控'
        }
    },
    {
      path: '/org-theBalanceof',
      component: resolve => require(['../../views/moneyManagement/theBalanceof/org-theBalanceof.vue'], resolve),
      meta: {
        title: '下属门店余额统计'
      }
    },
    {
      path: '/org-moneyMonitor',
      component: resolve => require(['../../views/moneyManagement/moneyMonitor/org-moneyMonitor.vue'], resolve),
      meta: {
        title: '下属门店资金监控'
      }
    },
  ]


// WEBPACK FOOTER //
// ./src/TASMini/router/modules/moneyManagement.js